import axios from 'axios'
import qs from 'qs'

import { normalizeError } from './utils'

const reindexService = () => {
  const fetchBrands = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/contentgraph/brands', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchVersions = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/contentgraph/versions', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchContentTypes = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/contentgraph/contenttypes', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchBrandStatus = async (accessToken, brandName, indexName, contentTypes) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get(`/api/contentgraph/status/${brandName}/${indexName}?${qs.stringify({ contentTypes })}`, config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchBrandProgress = async (accessToken, brandName) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get(`/api/contentgraph/progress/${brandName}`, config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const startReindex = async (accessToken, brandName, contentTypes) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.put(`/api/contentgraph/reindex/${brandName}?${qs.stringify({ contentTypes })}`, null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const stopReindex = async (accessToken, brandName) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.delete(`/api/contentgraph/reindex/${brandName}`, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const setVersions = async (accessToken, versions) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/contentgraph/versions`, versions, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const reindexById = async (accessToken, documentIds) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/contentgraph/reindex`, documentIds, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return {
    fetchBrands,
    fetchVersions,
    fetchContentTypes,
    fetchBrandStatus,
    fetchBrandProgress,
    startReindex,
    stopReindex,
    setVersions,
    reindexById,
  }
}

export default reindexService()
